import { createAPI } from '../../common'

export default {
  // 稿件知识属性分类接口
  WireCateGory: (config, vconfig = { neverLoading: false }) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0xjsf0dbufhpsz', 'get', config, vconfig),
  // 稿件产品线路分类接口
  Wireline: (config, vconfig = { neverLoading: false }) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0xjsf0xjsfmjof', 'get', config, vconfig),
  // 新华社选用文件夹树
  GetTakeTree: (config, vconfig = { neverLoading: false }) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0ublf0usff',
      'get',
      config,
      vconfig
    ),
  // 获取人员信息
  GetUsers: (config, vconfig = { neverLoading: false }) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0vtfsgpmefs0vtfst', 'get', config, vconfig)
}
